module.exports = __webpack_public_path__ + "img/outsourcing-image-01.b854aad9.webp";